<template lang="pug">
  keep-alive
    entity-input(
      v-if="autocompleteEntity"
      root-class="string"
      :class="rootClass"
      :leiCode="value"
      :tip="tip"
      :tip-placement="tipPlacement"
      :tipWidth="tipWidth"
      :label="label"
      :disabled="disabled"
      :rules="rules"
      @select="val => setInputValue(val.code, index)")
    date-picker.date(v-if="dataType === 'DATE'"
      @enter="enter"
      :root-class="rootClass"
      mode="single"
      :disabled="disabled"
      :label="label"
      :tip="tip"
      :tip-placement="tipPlacement"
      :months-to-show="1"
      :offset-y="getOffsetY(index)"
      :fullscreen-mobile="true"
      :date-one="value"
      @date-one-selected="val => setDateValue(val, index)")
    date-picker.date(v-if="dataType === 'DATE_RANGE'"
      @enter="enter"
      :disabled="disabled"
      :root-class="rootClass"
      :label="label"
      :tip="tip"
      placeholder="Start - End"
      :tip-placement="tipPlacement"
      :offset-y="getOffsetY(index)"
      :fullscreen-mobile="true"
      :date-one="value[0]"
      :date-two="value[1]"
      @date-one-selected="val => {setRangeValue(val, 0, index)}"
      @date-two-selected="val => {setRangeValue(val, 1, index)}")
    lei-input(v-if="dataType === 'STRING' || dataType === 'NUMBER'",
      :class="rootClass"
      @enter="enter"
      :disabled="disabled"
      :tip="tip"
      :tip-placement="tipPlacement"
      :tipWidth="tipWidth"
      root-class="string"
      :label="label"
      :type="dataType === 'STRING' ? 'text' : 'number'"
      :value="value"
      @input="val => setInputValue(val, index)")
    lei-input-range(v-if="dataType === 'NUMBER_RANGE'"
      :class="rootClass"
      @enter="enter"
      root-class="range"
      :tip="tip"
      :tip-placement="tipPlacement"
      :label="label"
      :min="value[0]"
      :max="value[1]"
      @input-min="val => {setRangeValue(val, 0, index)}"
      @input-max="val => {setRangeValue(val, 1, index)}")
    lei-filter.enum(v-if="dataType === type"
      v-for="({type, getLabel, multiple, setValue}, i) in enumSearchInputs(filter.resource)"
      :class="rootClass"
      select
      :tip="tip"
      :tipWidth="tipWidth"
      :disabled="disabled"
      :tip-placement="tipPlacement"
      :custom="rootClass !== 'input-creator'"
      :auto-items="items.length === 0"
      :filter="filter"
      :items="items"
      :multiple="multiple"
      :index="index"
      :key="i"
      :initial-value="value"
      :name="label"
      @choose="setValue"
      @change="setValue"
      :get-label='getLabel')
      template(slot-scope="{choice}" slot="choice" v-if="filter.resource === 'countries'")
        .choice.ellipsis
          img.flag(:src="getCountryFlagByCode(choice.code)")
          | {{getLabel(choice)}}
      template(slot-scope="{item}" v-if="filter.resource === 'countries'")
        .autocomplete-item
          img.flag(:src="getCountryFlagByCode(item.code)")
          | {{getLabel(item)}}
</template>
<script>
import LeiFilter from './LeiFilter'
import Autocomplete from './Autocomplete'
import DatePicker from './DatePicker'
import LeiInput from './LeiInput'
import LeiInputRange from './LeiInputRange'
import countries from '../../../constants/countries'
import { mapActions, } from 'vuex'
import { getLabelForResource, } from '../../../utils/resources'
import { getCountryFlagByCode, } from '../../../utils/countries'
import EntityInput from '@/components/lei-components/inputs/EntityInput'
import { timeFormat, } from '@/store/helpers'

export default {
  components: {
    EntityInput,
    LeiInputRange,
    LeiInput,
    DatePicker,
    Autocomplete,
    LeiFilter,
  },
  props: {
    dataType: {
      type: String,
      default: 'STRING',
    },
    label: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    rootClass: {
      type: String,
      default: 'input-creator',
    },
    tip: {
      type: [ String, Object, ],
      default: () => ({
        small: '',
        full: '',
      }),
    },
    tipPlacement: {
      type: [ String, ],
      default: 'bottom',
    },
    tipWidth: {
      type: Number,
      default: 220,
    },
    filter: {
      type: [ String, Object, ],
      default: () => ({
        resource: '',
      }),
    },
    items: {
      type: Array,
      default: () => [],
    },
    value: {
      type: [
        Array,
        Number,
        String,
        Object,
      ],
      default: '',
    },
    index: {
      type: Number,
      default: 0,
    },
    autocompleteEntity: {
      type: Boolean,
      default: false,
    },
    hasError: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: Array,
      default: () => [],
    },
  },
  data () {
    return {
      countries,
    }
  },
  methods: {
    getOffsetY: (i) => i === 0 ? 43 : 10,
    getLabel: (item) => item,
    getLabelForCountries: (item) => item.name,
    getCountryFlagByCode,
    enter () {
      this.$emit('enter')
    },
    setDateValue (value, index) {
      this.setInputValue(timeFormat(value), index)
    },
    setInputValue (value, index) {
      this.$emit('set-input-value', {
        value,
        index,
      })
    },
    setRangeValue (value, position, index) {
      this.$emit('set-range-value', {
        value,
        position,
        index,
      })
    },
    setEnumValue ({ item, index, }) {
      this.$emit('set-enum-value', {
        value: item,
        index,
      })
    },
    setEnumMultipleValue ({ value, index, }) {
      this.$emit('set-enum-value', {
        value,
        index,
      })
    },
    enumSearchInputs (resource) {
      return [
        {
          type: 'ENUM',
          getLabel: (item) => this.getLabel(item),
          setValue: (value) => this.setEnumValue(value),
        },
        {
          multiple: true,
          type: 'ENUM_IN',
          getLabel: (item) => this.getLabel(item),
          setValue: (value) => this.setEnumMultipleValue(value),
        },
        {
          type: 'RESOURCE',
          getLabel: (item) => getLabelForResource(resource, item),
          setValue: (value) => this.setEnumValue(value),
        },
        {
          multiple: true,
          type: 'RESOURCE_IN',
          getLabel: (item) => getLabelForResource(resource, item),
          setValue: (value) => this.setEnumMultipleValue(value),
        },
      ]
    },

    ...mapActions('search', [ 'getResources', ]),
  },
}
</script>
<style lang="stylus">
  @import "../../../assets/styles/variables.styl"
  .input-creator
    display flex
    width 100%

    &.lei-input .input:disabled,
    &.date .datepicker-input:disabled,
    &.enum.lei-filter.select.disabled .button-wrap .select-block
      color $disabled-color
      background-color $disabled-bg
      border-color $disabled-border!important
      cursor not-allowed!important
      .caret
        color $disabled-color

    .choice
      display flex
      align-items center
      line-height 1.5

    .flag
      width 20px
      margin-right 10px

    &.enum.lei-filter.select
      margin 0
      display flex

      .button-wrap
        height auto
        min-width 80px
        flex 1
        flex-direction column
        border-radius 0
        color $default-color-bold

        &.active .select-block
          border-color $input-border-active

        &:hover .select-block
          border-color $input-border-hover

        &.selected
          .category
            border-radius 0
            width fit-content

          .choice-block
            display none

        .select-block
          cursor pointer
          font-size $small-font-size
          color $input-color
          display flex
          height $input-sm
          overflow hidden
          background-color $white-color
          padding 15px 35px 15px 15px
          align-items center
          position relative
          border 1px solid $input-border

          .caret
            position absolute
            right 8px
            top 50%
            font-weight 600
            transform translateY(-50%)
            color $default-color-middle
            font-size 1rem
            transition all 0.3s ease

            &.open
              top 25%
              transform rotateZ(180deg)

        .category
          font-size 1rem
          font-weight 600
          padding 0
          margin-bottom 15px
          display inline-flex

    &.date
      position relative

      .clear
        display none

    &.string, &.date, &.range
      flex-direction column

      .label-tip-box
        margin-bottom 15px

      .label, .datepicker-label
        font-size 1rem
        color $default-color-bold
        font-weight 600
        display inline-flex

      .input, .datepicker-input
        width 100%
        font-size $small-font-size
        color $input-color
        font-weight 500
        background-color $white-color
        border 1px solid $input-border
        height $input-sm
        padding 15px 15px

        &:hover
          border-color $input-border-hover

        &:focus
          border-color $input-border-active
</style>



// WEBPACK FOOTER //
// src/components/lei-components/inputs/InputCreator.vue